export enum EdgeType {
  default = 'default',
  if = 'if',
  else = 'else',
}
